import React from 'react'

const Icon = ({ name, className = '' }) => {
  const common = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }

  switch (name) {
    case 'briefcase':
      return (
        <svg {...common} className={className}>
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M9 7V6a3 3 0 0 1 3-3h0a3 3 0 0 1 3 3v1" />
          <path d="M3 12h18" />
        </svg>
      )

    case 'pin':
      return (
        <svg {...common} className={className}>
          <path d="M12 21s6-5.1 6-11a6 6 0 0 0-12 0c0 5.9 6 11 6 11Z" />
          <circle cx="12" cy="10" r="2.2" />
        </svg>
      )

    case 'calendar':
      return (
        <svg {...common} className={className}>
          <rect x="3" y="5" width="18" height="16" rx="2" />
          <path d="M3 9h18" />
          <path d="M8 3v4M16 3v4" />
        </svg>
      )

    case 'money':
      return (
        <svg {...common} className={className}>
          <path d="M12 2v20" />
          <path d="M17 6.5c0-1.9-2.2-3.5-5-3.5s-5 1.6-5 3.5 2 3 5 3 5 1.1 5 3.5-2.2 3.5-5 3.5-5-1.6-5-3.5" />
        </svg>
      )

    case 'mail':
      return (
        <svg {...common} className={className}>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m4 7 8 6 8-6" />
        </svg>
      )

    case 'globe':
      return (
        <svg {...common} className={className}>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c2.8 3 4 6 4 9s-1.2 6-4 9c-2.8-3-4-6-4-9s1.2-6 4-9Z" />
        </svg>
      )

    case 'phone':
      return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden className={className}>
          <path d="M1.26855 0.5H4.76855C4.95229 0.500011 5.07991 0.55472 5.18457 0.65332C5.27807 0.741412 5.35658 0.855859 5.41504 1.00684L5.4668 1.16992L6.13184 4.18359C6.1645 4.41538 6.15698 4.60038 6.12207 4.74707C6.09092 4.87804 6.02914 4.98631 5.92969 5.08105L5.92285 5.08691L3.40527 7.57031L3.12598 7.8457L3.32617 8.18164C3.75291 8.89877 4.20639 9.57129 4.68652 10.1973C5.16934 10.8268 5.70553 11.4248 6.29395 11.9922C6.90732 12.6254 7.54853 13.2006 8.21777 13.7158C8.89293 14.2356 9.59837 14.6906 10.334 15.0801L10.665 15.2549L10.9258 14.9873L13.3311 12.5195L13.3408 12.5088C13.4804 12.3574 13.627 12.2663 13.7832 12.2197C13.9142 12.1809 14.044 12.1673 14.1748 12.1768L14.3066 12.1943L17.127 12.8184C17.2927 12.8645 17.4245 12.9359 17.5312 13.0303L17.6309 13.1328C17.7476 13.2738 17.8047 13.4317 17.8047 13.626V17.0361C17.8047 17.2731 17.7305 17.4447 17.5869 17.5869C17.4405 17.7319 17.2676 17.8047 17.0361 17.8047C15.161 17.8046 13.2407 17.3544 11.2715 16.4395C9.30334 15.525 7.47245 14.2244 5.7793 12.5312C4.19223 10.9442 2.9492 9.23511 2.04492 7.4043L1.86816 7.03613C0.951129 5.06465 0.5 3.14535 0.5 1.27441C0.500013 1.09656 0.541272 0.954083 0.623047 0.833008L0.71875 0.71875C0.862804 0.573905 1.03455 0.5 1.26855 0.5ZM1.21582 1.73047C1.24675 2.44345 1.35877 3.19177 1.54883 3.97363C1.7404 4.76166 2.04011 5.63145 2.44434 6.58008L2.7334 7.25879L3.25684 6.73828L5.27637 4.73047L5.46973 4.53809L5.41211 4.27148L4.84375 1.60449L4.75879 1.20898H1.19336L1.21582 1.73047ZM17.0957 13.5322L16.6973 13.4502L14.2119 12.9355L13.9404 12.8799L13.748 13.0801L11.7852 15.1377L11.3037 15.6416L11.9365 15.9365C12.6314 16.2598 13.3848 16.5217 14.1943 16.7246C15.005 16.9277 15.7972 17.0497 16.5703 17.0889L17.0957 17.1152V13.5322Z" fill="currentColor" stroke="currentColor"/>
        </svg>
      )

    case 'search':
      return (
        <svg {...common} className={className}>
          <circle cx="11" cy="11" r="7" />
          <path d="m20 20-3.5-3.5" />
        </svg>
      )

    case 'download':
      return (
        <svg {...common} className={className}>
          <path d="M12 3v11" />
          <path d="m8 10 4 4 4-4" />
          <path d="M4 19h16" />
        </svg>
      )

    case 'preview':
      return (
        <svg {...common} className={className}>
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      )

    case 'edit':
      return (
        <svg {...common} className={className}>
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />
        </svg>
      )

    case 'trash':
      return (
        <svg {...common} className={className}>
          <path d="M3 6h18" />
          <path d="M8 6V4h8v2" />
          <path d="M6 6l1 14h10l1-14" />
          <path d="M10 11v5M14 11v5" />
        </svg>
      )

    case 'clock':
      return (
        <svg {...common} className={className}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      )

    case 'user':
      return (
        <svg {...common} className={className}>
          <circle cx="12" cy="8" r="3" />
          <path d="M5 20c1.5-4 4.5-6 7-6s5.5 2 7 6" />
        </svg>
      )

    case 'linkedin':
      return (
        <svg {...common} className={className}>
          <rect x="3" y="3" width="18" height="18" rx="4" />
          <path d="M7 10v7" />
          <path d="M7 7.5h.01" />
          <path d="M11 17v-4a2 2 0 0 1 4 0v4" />
        </svg>
      )

    case 'building':
      return (
        <svg {...common} className={className}>
          <rect x="5" y="3" width="14" height="18" rx="2" />
          <path d="M9 7h.01M9 11h.01M9 15h.01M13 7h.01M13 11h.01M13 15h.01" />
        </svg>
      )

    case 'copy':
      return (
        <svg {...common} className={className}>
          <rect x="9" y="9" width="11" height="11" rx="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      )

    default:
      return null
  }
}

export default Icon